import { apiGet } from '@/shared/utils/requestBuilder';

import type {
  ActiveContractByCategory,
  ContractCategory,
  EffectiveUnitPrice,
  TrialStatusResponse,
} from '../types';

// O backend deste PR vai antes do front, mas um rollback dele deixaria o payload sem os campos
// da segunda métrica — e o tipo os promete como `number`. Normalizar aqui é o que mantém o
// contrato honesto durante a janela de deploy, no mesmo padrão já usado para `paymentMode`.
function normalizarPeriodo(
  periodo: ActiveContractByCategory['currentPeriod'],
): ActiveContractByCategory['currentPeriod'] {
  if (!periodo) return null;
  return {
    ...periodo,
    messageUsed: periodo.messageUsed ?? 0,
    messageBalance: periodo.messageBalance ?? null,
    messageAtLimit: periodo.messageAtLimit ?? false,
  };
}

export const contractsService = {
  async fetchActiveByCategory(category: ContractCategory): Promise<ActiveContractByCategory> {
    const response = await apiGet('/products/contracts/active-by-category', { category });
    const json = await response.json().catch(() => null);
    if (!response.ok) {
      throw new Error(json?.error?.message ?? 'Falha ao verificar contrato ativo');
    }
    const data = json.data as ActiveContractByCategory;
    return {
      ...data,
      paymentMode: data.paymentMode ?? 'prepaid',
      currentPeriod: normalizarPeriodo(data.currentPeriod),
    };
  },

  async fetchEffectiveUnitPrice(category: ContractCategory): Promise<EffectiveUnitPrice> {
    const response = await apiGet('/products/contracts/effective-unit-price', { category });
    const json = await response.json().catch(() => null);
    if (!response.ok) {
      throw new Error(json?.error?.message ?? 'Falha ao obter valor unitário do contrato');
    }
    return json.data as EffectiveUnitPrice;
  },

  async fetchTrialStatus(): Promise<TrialStatusResponse> {
    const response = await apiGet('/products/contracts/trial-status');
    const json = await response.json().catch(() => null);
    if (!response.ok) {
      throw new Error(json?.error?.message ?? 'Falha ao obter o status do teste');
    }
    return json.data as TrialStatusResponse;
  },
};
